import {Injectable} from '@angular/core';

import {HTTPHelperService} from './http-helper.services';

@Injectable()
export class AdminService {

  constructor(private httpHelper: HTTPHelperService) {
  }

  public get({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public post({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public put({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public delete({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public getBootstrap({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public getProfile({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadAcademicYear({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public deleteAcademicYear({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public copyAcademicYear({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editAcademicYear({url, params}) {
    if (params.clone_from && params.delete_original) {
      delete params.clone_from;
      delete params.delete_original;
      return this.httpHelper.postFunction({url: url, params: params});
    } else {
      delete params.clone_from;
      delete params.delete_original;
      return this.httpHelper.putFunction({url: url, params: params});
    }
  }

  public addAcademicYear({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadSection({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addSection({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteSection({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public loadClass({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addClass({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteClass({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editClass({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadDiscount({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public editDiscount({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteDiscount({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public addDiscount({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadBankInfo({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadFixedFeeInfo({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public editBankInfo({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteBankInfo({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public addBankInfo({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadFeeTerm({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addFeeTerm({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteFeeTerm({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editFeeTerm({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadFeeTermClass({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addFeeTermClass({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteFeeTermClass({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editFeeTermClass({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadEvent({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addEvent({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteEvent({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editEvent({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadHoliday({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addHoliday({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteHoliday({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editHoliday({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadFeedback({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public editFeedback({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadContactUs({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addContactUs({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editContactUs({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadStudentLeave({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStudentLeave({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteStudentLeave({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editStudentLeave({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadStudentPermission({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStudentPermission({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteStudentPermission({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editStudentPermission({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public pdfDownloadPermission({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStaffLeave({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStaffLeave({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteStaffLeave({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editStaffLeave({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadStaffPermission({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStaffPermission({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteStaffPermission({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editStaffPermission({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadExam({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addExam({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteExam({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editExam({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadEnquiry({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addEnquiry({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteEnquiry({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editEnquiry({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadStudentAttendance({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStaffAttendance({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStudentList({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public getStudentById({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public updateAttendance({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public saveAttendance({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadSubject({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addSubject({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteSubject({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editSubject({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public allocatedStaff({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadStaff({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadLoginActivity({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public addStaff({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public addStaffCred({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editStaffCred({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteStaff({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editStaff({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public getStaffById({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public updateStaffMobile({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadNonStaff({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addNonStaff({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteNonStaff({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editNonStaff({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadChapter({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addChapter({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteChapter({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editChapter({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadObjQuestion({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addObjQuestion({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteObjQuestion({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editObjQuestion({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadSubjectByClassSection({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public setStaff({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public addTimeTable({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteTimeTable({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editTimeTable({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadStaffTimetable({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadUnallocatedStaff({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStudent({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStudent({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editStudent({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteStudent({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public loadStudentPerformance({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadCategory({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addCategory({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteCategory({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public editCategory({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadGallery({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addGallery({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteGallery({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public EditGallery({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public editGallery({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public getImage({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public uploadImage(url, formData) {
    return this.httpHelper.postImageUpload(url, formData);
  }

  public loadSchoolFeesPaid({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadFeesPaidCount({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStudentsPaidData({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addStudentsPaidData({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editStudentsPaidData({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public loadFeesCollectionGraphData({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadTermFeesNotPaidData({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadObjectiveExamResult({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadExamResult({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadExamMarkList({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addExamMarkList({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editExamMarkList({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public publishExamResult({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public printReportCard({url, params}) {
    return this.httpHelper.postPdfDownload({url: url, params: params});
  }

  public printTc({url, params}) {
    return this.httpHelper.postTcPdfDownload({url: url, params: params});
  }

  public postMergePdf({url, params}) {
    return this.httpHelper.postPdfMerge({url: url, params: params});
  }

  public loadDashboard({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public getUploadURL({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public uploadImageForGallery({url, params}) {
    return this.httpHelper.putFunctionForImage({url: url, params: params});
  }

  public listPhotosInGallery({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public deletePhotoFromGallery({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public loadGroup({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadGroupParticipants({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addGroup({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public addGroupParticipants({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editGroup({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public updateGroup({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteGroup({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public deleteNotification({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public loadAdminNotification({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadAdminPendingNotification({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStudentNotification({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminNotificationToGroup({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminNotificationToStaff({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminNotificationToMember({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminNotificationToStudent({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminNotificationToClass({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadAdminSms({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public postAdminSMSToClass({url, params}) {
      return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminSMSToStudent({url, params}) {
      return this.httpHelper.postFunction({url: url, params: params});
  }

  public postAdminSMSToGroup({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public getTodayAbsentees({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadAnnouncement({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public postAdminApproveNotification({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postCsvDownload({url, params}) {
    return this.httpHelper.downloadReport({url: url, params: params});
  }
  public getInactiveList({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }
  public addNewAcademicYear({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }
  public listNewAcademicYear({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }
  public deleteNewAcademicYear({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }
  public postStudentPromotion({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }
  public postTransferStudent({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }
  public postApplyTC({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }
  public updateTC({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }
}
